import React, { useCallback, useState } from 'react';
import { Box } from '@mui/material';
import './custom-offices.css';
import ModalOfficeAdmin from './modalOfficeAdmin';
import { useOffices } from '../../../hooks/Offices/useOffices';
import { SectionHeader, UIPageHeader } from '../../utilities/Headers';
import UITable, { UITableHeadCell } from '../../utilities/Table';
import { UIButton } from '../../utilities/Button';
import { IconAffiliate, IconEdit, IconPlus } from '@tabler/icons-react';
import ModalOfficeConnectedAdmin from './modalOfficeConnectedAdmin';

const OfficesView = () => {
  const [selectedOffice, setSelectedOffice] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [connectedMode, setConnectedMode] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);

  const { onListOfficesAdminPaginated } = useOffices();

  const handleModalClose = useCallback(() => {
    setEditMode(false);
    setConnectedMode(false);
    setSelectedOffice(null);
    setForceUpdate(true);
  }, []);

  const prepareValues = (offices) =>
    offices?.map((office) => {
      return {
        office: office,
        NameEl: <Box>{office?.name}</Box>,
        actionsEl: (
          <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'} mr={'15px'}>
            <UIButton
              type={'icon'}
              onClick={() => {
                setSelectedOffice(office);
                setEditMode(true);
              }}
              icon={
                <IconEdit
                  stroke={'1.67px'}
                  style={{
                    width: '24px'
                  }}
                />
              }
            />
            <UIButton
              type={'icon'}
              onClick={() => {
                setSelectedOffice(office);
                setConnectedMode(true);
              }}
              icon={
                <IconAffiliate
                  stroke={'1.67px'}
                  style={{
                    width: '24px'
                  }}
                />
              }
            />
          </Box>
        )
      };
    });

  const columns = [
    {
      name: <UITableHeadCell title={'Nome'} />,
      value: 'NameEl',
      size: 80
    },
    {
      name: '',
      value: 'actionsEl',
      size: 80
    }
  ];

  return (
    <Box className="products-view" w={'100%'} h={'100%'} overflow={'auto'}>
      <Box
        position={'fixed'}
        display={'flex'}
        right={10}
        bottom={10}
        bgcolor={'#2c3e50'}
        p={'10px'}
        borderRadius={'100%'}
        w={'50px'}
        h={'50px'}
        color={'white'}
        justifyContent={'center'}
        alignItems={'center'}
        cursor={'pointer'}
        onClick={() => {
          setSelectedOffice(null);
          setEditMode(true);
        }}
      >
        <IconPlus stroke={3} size="2rem" />
      </Box>

      <ModalOfficeAdmin modalOpen={editMode} handleModalClose={handleModalClose} office={selectedOffice} />
      <ModalOfficeConnectedAdmin
        modalOpen={connectedMode}
        handleModalClose={handleModalClose}
        office={selectedOffice}
        setConnectedMode={setConnectedMode}
      />

      <UIPageHeader title={'Cliniche'} subtitle={'La lista delle cliniche esistenti. Puoi aggiungere, modificare o eliminare le città.'} />
      <SectionHeader title={'Clinica'} />
      <UITable
        columns={columns}
        prepareValues={prepareValues}
        enableSearch={true}
        infiniteScrollEndMessage={'Non ci sono altre cliniche da mostrare'}
        infiniteScrollFunction={onListOfficesAdminPaginated}
        tableHeight={'calc(100vh - 450px)'}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        muiTableBodyRowProps={(data) => {
          return {
            sx: {
              bgcolor: data?.row?.original?.date ? '#FDF2B5' : '',
              p: 0,
              '& td': data?.row?.original?.date
                ? {
                    p: '5px 20px'
                  }
                : {}
            }
          };
        }}
      />
    </Box>
  );
};
export default OfficesView;
